import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import './index.css'
import '@/i18n'

import App from './App.tsx'

const env = (import.meta.env.VITE_ENV as string) ?? 'dev'
const icon = `/icon-${env.toLocaleLowerCase()}.svg`
document.getElementById('favicon-app')?.setAttribute('href', icon)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
